import React from 'react';
import { Link, useLocation } from 'react-router-dom';

export function Header() {
  const location = useLocation();
  
  const isActive = (path: string) => {
    return location.pathname === path ? 'text-[#3C7CD6]' : 'text-gray-600 hover:text-gray-900';
  };

  return (
    <nav className="bg-white border-b border-gray-200 fixed w-full z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          <Link to="/">
            <img 
              src="/images/omnylink_logo.png" 
              alt="Omnylink" 
              className="h-8 w-auto"
            />
          </Link>
          <div className="flex items-center space-x-8">
            <div className="flex gap-4">
              <Link
                to="/login"
                className="inline-flex items-center justify-center px-4 py-2 border border-[#3C7CD6] text-sm font-medium rounded-md text-[#3C7CD6] bg-white hover:bg-blue-50 transition-colors"
              >
                Login
              </Link>
              <Link
                to="/signup"
                className="inline-flex items-center justify-center px-4 py-2 border border-transparent text-sm font-medium rounded-md text-white bg-[#3C7CD6] hover:bg-[#4A8DE0] transition-colors"
              >
                Get Started
              </Link>
            </div>
          </div>
        </div>
      </div>
    </nav>
  );
}